"use client";

import { useState, useEffect } from "react";
import { customPageData } from "@/lib/helpers";

export default function usePage(pageSlug) {
    const [page, setPage] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!pageSlug) {
            setLoading(false);
            return;
        }

        const fetchPage = async () => {
            setLoading(true);
            try {
                const data = await customPageData(pageSlug);

                if (!data || data?.remark === "page_not_found") {
                    setPage(null);
                } else {
                    setPage(data);
                }
            } catch (error) {
                setPage(null);
            } finally {
                setLoading(false);
            }
        };

        fetchPage();
    }, [pageSlug]);

    return { page, loading };
}
